import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {OptionsMapper} from "@magieno/angular-advanced-forms";
import { AlertMessageStore } from '../../../../core/stores/alert-message.store';
import { Quebec2022TaxFormFactory } from './quebec-2022-tax-form.factory';
import { ClientQuestionnaireBase } from '../../base-client-questionnaire/form/base-form/client-questionnaire.base';

import { ClientQuestionnaireStore } from '../../../stores/client-questionnaire.store';

import {
  PrescriptionDrugInsuranceEnum,
} from '../../../../../../../../../common/src/enums/prescription-drug-insurance.enum';
import {
  MainSpouseQuebec2022TaxQuestionnaireOptions,
} from '../../../../../../../../../common/src/options/client-questionnaire/quebec-2022-tax-questionnaire/main-spouse-quebec-2022-tax-questionnaire.options';
import { CivilStatusEnum } from '../../../../../../../../../common/src/enums/civil-status.enum';
import { ErrorsUtils } from '../../../../core/utils/errors.utils';
import { LoggingService } from '../../../../core/services/logging.service';

@Component({
  selector: 'app-quebec-2022-tax-form',
  templateUrl: './quebec-2022-tax-form.component.html',
  styleUrls: ['./quebec-2022-tax-form.component.scss'],
  standalone: false,
})
export class Quebec2022TaxFormComponent extends ClientQuestionnaireBase<MainSpouseQuebec2022TaxQuestionnaireOptions> implements OnInit, OnDestroy {
  prescriptionDrugInsuranceEnum = PrescriptionDrugInsuranceEnum;

  isMainSpouseTab: boolean = true;

  civilStatusEnum = CivilStatusEnum;

  constructor(public readonly formFactory: Quebec2022TaxFormFactory,
              clientQuestionnaireStore: ClientQuestionnaireStore,
              translateService: TranslateService,
              activatedRoute: ActivatedRoute,
              modalService: NgbModal,
              router: Router,
              optionsMapper: OptionsMapper,
              // calculationsUtils: CalculationsUtils,
              alertMessageStore: AlertMessageStore,
              errorsUtils: ErrorsUtils,
              loggingService: LoggingService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
    super(formFactory, clientQuestionnaireStore, translateService, activatedRoute, modalService, router, optionsMapper, alertMessageStore, errorsUtils, loggingService);
    this.optionsType = MainSpouseQuebec2022TaxQuestionnaireOptions;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}

